import React from 'react'
import Day from './Day'

const Week = ({week}) => {
  return (
    <div className='flex-rows-start'>
      {week.map((row,i)=>(
        <Day day={row} key={i} rowIdx={i} dayType={"week"}/>
      ))}

    </div>
  )
}

export default Week